module.exports = __webpack_public_path__ + "static/media/VälkommentillDysmate.f154876d.mp3";